import axios from '../utils/axios';

const apiPrefix = '/api/job-board';

/**
 * Fire-and-forget recording of a single job-quality-survey event.
 * Analytics failures must never disrupt the browsing experience, so errors are swallowed.
 */
const recordSurveyEvent = async (payload) => {
	try {
		await axios.post(`${apiPrefix}/quality-survey-events`, payload);
	} catch {
		return null;
	}
};

export { recordSurveyEvent };
